import { ActionError } from '@/common/exceptions'

export const PLATFORM_ACTION_EMPTY_CODE = 'PLATFORM_ACTION_EMPTY'
export const PLATFORM_ACTION_INCOMPLETE_CODE = 'PLATFORM_ACTION_INCOMPLETE'

/** actionType=1 — MENU_ACTION (открытие пункта меню / getPage). */
export const MENU_ACTION_TYPE = 1

/** actionType=3 — SERVICE_ACTION (startup-action / doServiceAction). */
export const SERVICE_ACTION_TYPE = 3

export function isPlatformActionBodyEmpty(data: unknown): boolean {
  if (data == null) {
    return true
  }
  if (typeof data === 'string') {
    return data.trim() === ''
  }
  if (typeof data === 'object' && !Array.isArray(data)) {
    return Object.keys(data as object).length === 0
  }
  return false
}

function hasNonEmptyFormField(form: unknown): boolean {
  if (form == null) {
    return false
  }
  if (typeof form === 'string') {
    return form.trim().length > 0
  }
  return typeof form === 'object'
}

function hasOpenStack(stack: unknown): boolean {
  return Array.isArray(stack) && stack.length > 0
}

function hasValidSessionId(sessionId: unknown): boolean {
  if (sessionId == null) {
    return false
  }
  const s = String(sessionId).trim()
  return s !== '' && s !== '-1'
}

/**
 * Проверяет ответ POST /platform/action.
 * Пустое тело (0 байт / "" / {}) и неполный ответ при открытии меню → ActionError.
 */
export function assertPlatformActionResponse(
  data: unknown,
  params: { actionId?: string | number; actionType?: number },
): asserts data is Record<string, unknown> {
  const actionId = params.actionId ?? '?'

  if (isPlatformActionBodyEmpty(data)) {
    throw new ActionError(
      PLATFORM_ACTION_EMPTY_CODE,
      `Empty HTTP body for platform/action (actionId=${actionId}). ` +
        'Check VITE_PROXY_TARGET, workflow-web-server logs (platform/action timings), and auth cookies.',
      `Пустой ответ platform/action (actionId=${actionId})`,
    )
  }

  const doc = data as Record<string, unknown>
  const actionType = Number(params.actionType)
  if (actionType !== MENU_ACTION_TYPE) {
    return
  }

  const sessionId = doc.sessionId
  const hasForm = hasNonEmptyFormField(doc.form)
  const status = Number(doc.status)
  const statusIndicatesOpen = Number.isFinite(status) && status > 0
  const hasStack = hasOpenStack(doc.stack)

  if (
    hasValidSessionId(sessionId) &&
    (hasForm || (statusIndicatesOpen && hasStack))
  ) {
    return
  }

  throw new ActionError(
    PLATFORM_ACTION_INCOMPLETE_CODE,
    `Incomplete platform/action for menu open (actionId=${actionId}): ` +
      `sessionId=${sessionId ?? 'missing'}, status=${String(doc.status ?? 'missing')}, hasForm=${hasForm}`,
    `Не удалось открыть форму (actionId=${actionId}): в ответе нет form и корректного sessionId`,
  )
}
